import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.StickyNotes';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class StickyNotes extends RpcClass{

    /**
     *  @class StickyNotes
     *  @alias module:src/server/com/silkplm/rpc/StickyNotes.StickyNotes
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param leftOffset {number} 
     * @param topOffset {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     addPinnedStickyNote(leftOffset, topOffset) {
            return RpcClass.rpcCall('/rpc/sticky-notes/add-pinned-sticky-note', [leftOffset, topOffset]);
    }
    /** 
     * @async
     * @param businessEntityClass {string} 
     * @param businessEntityId {string} 
     * @param leftOffset {number} 
     * @param topOffset {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     addPinnedStickyNoteToBusinessEntity(businessEntityClass, businessEntityId, leftOffset, topOffset) {
            return RpcClass.rpcCall('/rpc/sticky-notes/add-pinned-sticky-note-to-business-entity', [businessEntityClass, businessEntityId, leftOffset, topOffset]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     addStickyNote() {
            return RpcClass.rpcCall('/rpc/sticky-notes/add-sticky-note', []);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteStickyNote(id) {
            return RpcClass.rpcCall('/rpc/sticky-notes/delete-sticky-note', [id]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     getNumberOfStickyNotes() {
            return RpcClass.rpcCall('/rpc/sticky-notes/get-number-of-sticky-notes', []);
    }
    /** 
     * @async
     * @param stickyNoteId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     getStickyNote(stickyNoteId) {
            return RpcClass.rpcCall('/rpc/sticky-notes/get-sticky-note', [stickyNoteId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote[]>}
     */
     listPinStickyNotes() {
            return RpcClass.rpcCall('/rpc/sticky-notes/list-pin-sticky-notes', []);
    }
    /** 
     * @async
     * @param formId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote[]>}
     */
     listPinStickyNotesInBusinessEntityObj(formId) {
            return RpcClass.rpcCall('/rpc/sticky-notes/list-pin-sticky-notes-in-business-entity-obj', [formId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote[]>}
     */
     listStickyNotes() {
            return RpcClass.rpcCall('/rpc/sticky-notes/list-sticky-notes', []);
    }
    /** 
     * @async
     * @param stickyNote {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     pinStickyNote(stickyNote) {
            return RpcClass.rpcCall('/rpc/sticky-notes/pin-sticky-note', [stickyNote]);
    }
    /** 
     * @async
     * @param stickyNoteId {string} 
     * @param leftOffset {number} 
     * @param topOffset {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     setPositionOfStickyNote(stickyNoteId, leftOffset, topOffset) {
            return RpcClass.rpcCall('/rpc/sticky-notes/set-position-of-sticky-note', [stickyNoteId, leftOffset, topOffset]);
    }
    /** 
     * @async
     * @param stickyNote {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     unpinStickyNote(stickyNote) {
            return RpcClass.rpcCall('/rpc/sticky-notes/unpin-sticky-note', [stickyNote]);
    }
    /** 
     * @async
     * @param stickyNote {module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/sticky/StickyNote.StickyNote>}
     */
     updateStickyNote(stickyNote) {
            return RpcClass.rpcCall('/rpc/sticky-notes/update-sticky-note', [stickyNote]);
    }
    /** 
     * @async
     * @param text {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/rpc/validators/FieldValidationResult.FieldValidationResult>}
     */
     validateStickyNote(text) {
            return RpcClass.rpcCall('/rpc/sticky-notes/validate-sticky-note', [text]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.StickyNotes';
metadata.__type_short__ = 'StickyNotes';
StickyNotes.prototype.__metadata__ = metadata;

StickyNotes.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/StickyNotes */
export default StickyNotes

export { StickyNotes }
